import React, { useState, useRef } from 'react';
import { Form, FormGroup, Spinner } from 'reactstrap';
import Btn from '../../shims/commonUiBtn';
import { addComment } from '../../api/ticketApi';

const MAX_LENGTH = 5000;

export default function AddCommentForm({ ticketId, onCommentAdded }) {
  const [body, setBody] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const textareaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!body?.trim()) {
      setError('Comment cannot be empty');
      return;
    }
    setIsLoading(true);
    try {
      const comment = await addComment(ticketId, body.trim());
      onCommentAdded?.(comment);
      setBody('');
    } catch (err) {
      setError(err?.json?.message || err?.json?.error || 'Failed to add comment.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setBody(e.target.value.slice(0, MAX_LENGTH));
    const ta = e.target;
    ta.style.height = 'auto';
    ta.style.height = `${Math.min(ta.scrollHeight, 300)}px`;
  };

  return (
    <Form className="theme-form mt-2" onSubmit={handleSubmit}>
      <FormGroup className="form-group mb-2">
        <textarea
          ref={textareaRef}
          className={`form-control${error ? ' is-invalid' : ''}`}
          rows={3}
          placeholder="Add a comment..."
          value={body}
          onChange={handleChange}
          disabled={isLoading}
          maxLength={MAX_LENGTH}
          aria-label="Add a comment"
          style={{ overflowY: 'hidden' }}
        />
        {error && (
          <div className="invalid-feedback d-block" role="alert">
            {error}
          </div>
        )}
        <small className="text-muted d-block mt-1" aria-live="polite">
          {MAX_LENGTH - body.length} characters remaining
        </small>
      </FormGroup>
      <div className="d-flex align-items-center gap-2">
        <Btn attrBtn={{ type: 'submit', disabled: isLoading, color: 'primary' }}>
          {isLoading ? <Spinner size="sm" color="light" /> : 'Submit'}
        </Btn>
      </div>
    </Form>
  );
}

export function focusAddCommentForm(ref) {
  ref?.current?.focus?.();
}
